/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Sources_LabelInputs */



/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Voice_Manager_Sources_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_sources_label = /** @type {((inputs?: Voice_Manager_Sources_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Sources_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sources")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источники")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuentes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fontes")
	return /** @type {LocalizedString} */ ("Sources")
});